import { UseMutationOptions, useMutation } from '@tanstack/react-query';

import { CalendarDto, CalendarService } from 'src/Services/API';

export const useEditAgencyCalendar = (
  config?: UseMutationOptions<
    void,
    Error,
    { agencyId: string; calendarObjectId: string; body: CalendarDto },
    unknown
  >
) => {
  return useMutation(async params => {
    return await CalendarService.calendarControllerEditCalendar(params);
  }, config);
};
